import React from 'react';
import PropTypes from 'prop-types';
import { ViewTitle } from 'components/ViewTitle';
import { BackButton } from 'components/Button';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import * as actions from '../../redux/action';
import FormGroupEmployee from '../../components/Forms/FormGroupEmployee';

function NewGroupEmployee({ title, subtitle }) {
  const { handleSubmit, control } = useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;
  const renderBackbuttom = () => <BackButton />;

  const onSubmit = async (data) => {
    const confirm = window.confirm('บันทึกข้อมูล');
    if (confirm) {
      try {
        await dispatch(actions.groupCreate(data));
        await dispatch(actions.groupGetAll({}));
        alert('บันทึกสำเร็จ');
        history.goBack();
      } catch (error) {
        console.log('error');
      }
    }
  };

  const renderForm = () => (
    <di>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormGroupEmployee control={control} Controller={Controller} />
      </form>
    </di>
  );

  return (
    <div>
      <div>
        {renderTitle()}
        {renderBackbuttom()}
      </div>
      <div>{renderForm()}</div>
    </div>
  );
}

NewGroupEmployee.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};
NewGroupEmployee.defaultProps = {
  title: '',
  subtitle: '',
};

export default NewGroupEmployee;
